import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import studentsServices from "./studentsServices";

const initialState = {
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
  studentsData: null,
  totalCount: 0,
  isLoadingforSearch: false,
  isErrorforSearch: false,
  messageforSearch: false,
  searchText: "",
  courseSearchText: "",
  examSearchText: "",
  studentById: null,
  studentId: null,
  applicationData: null,
  applicationById: null,
  blogData: null,
  blogById: null,
  reviewsData: null,
  reviewById: null,
  contactUsData: null,
  callRequestData: null,
  courseOrdersData: null,
  examOrdersData: null,
  isNewBlog: true,
  batchOrderData: null,
  availableCourseById: null,
  availableCourseData: null,
  availableExamData: null,
  availableExamById: null
};

export const getStudents = createAsyncThunk(
    "students/getStudents",
    async (params, thunkAPI) => {
      try {
        return await studentsServices.getStudents(params);
      } catch (error) {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
);

export const getStudentById = createAsyncThunk(
  "students/getStudentById",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getStudentById(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getApplication = createAsyncThunk(
  "students/getApplication",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getApplication(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getApplicationById = createAsyncThunk(
  "students/getApplicationById",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getApplicationById(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateApplication = createAsyncThunk(
  "students/updateApplication",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.updateApplication(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getBlogs = createAsyncThunk(
  "blogs/getBlogs",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getBlogs(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addBlog = createAsyncThunk(
  "blogs/addBlog",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.addBlog(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getReviews = createAsyncThunk(
  "review/getReviews",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getReviews(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCallRequests = createAsyncThunk(
  "blogs/getCallRequests",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getCallRequests(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCourseOrders = createAsyncThunk(
  "blogs/getCourseOrders",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getCourseOrders(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getBatchOrders = createAsyncThunk(
  "blogs/getBatchOrders",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getBatchOrders(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getExamOrders = createAsyncThunk(
  "blogs/getExamOrders",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getExamOrders(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addNewCourse = createAsyncThunk(
  "courses/addNewCourse",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.addNewCourse(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addNewExam = createAsyncThunk(
  "courses/addNewExam",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.addNewExam(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAvailableExamById = createAsyncThunk(
  "courses/getAvailableExamById",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getAvailableExamById(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAvailableCourses = createAsyncThunk(
  "courses/getAvailableCourses",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getAvailableCourses(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAvailableExams = createAsyncThunk(
  "courses/getAvailableExams",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getAvailableExams(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAvailableCourseById = createAsyncThunk(
  "courses/getAvailableCourseById",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getAvailableCourseById(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateCourse = createAsyncThunk(
  "courses/updateCourse",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.updateCourse(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateExam = createAsyncThunk(
  "courses/updateExam",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.updateExam(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateBlog = createAsyncThunk(
  "blogs/updateBlog",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.updateBlog(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getBlogById = createAsyncThunk(
  "blogs/getBlogById",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getBlogById(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteReview = createAsyncThunk(
  "review/deleteReview",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.deleteReview(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteContactUs = createAsyncThunk(
  "contact/deleteContactUs",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.deleteContactUs(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getReviewById = createAsyncThunk(
  "review/getReviewById",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getReviewById(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getContactUs = createAsyncThunk(
  "contact/getContactUs",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.getContactUs(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addReview = createAsyncThunk(
  "review/addReview",
  async (params, thunkAPI) => {
    try {
      return await studentsServices.addReview(params);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const studentsSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    setStudentsFilterDetails: (state, action) => {
      state.searchText = action.payload;
    },
    setCourseSearchText: (state, action) => {
      state.courseSearchText = action.payload;
    },
    setExamSearchText: (state, action) => {
      state.examSearchText = action.payload;
    },
    setStudentsById: (state, action) => {
      state.studentId = action.payload;
    },
    setReviewById: (state, action) => {
      state.reviewById = action.payload;
    },
    setSetIsNewBlog: (state, action) => {
      state.isNewBlog = action.payload;
    },
    setSetBlogById: (state, action) => {
      state.blogById = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStudents.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStudents.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getStudents.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.totalCount = action.payload.data?.totalCount;
        state.studentsData = action.payload.data?.result;
      })
      .addCase(getStudentById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStudentById.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getStudentById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.studentById = action.payload.data;
        state.message = action.payload.message;
      })
      .addCase(updateApplication.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateApplication.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(updateApplication.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
      })
      .addCase(getApplication.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getApplication.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.totalCount = action.payload.data?.totalCount;
        state.applicationData = action.payload.data.result;
      })
      .addCase(getApplicationById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getApplicationById.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getApplicationById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.applicationById = action.payload.data;
      })
      .addCase(getBlogs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBlogs.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getBlogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.blogData = action.payload.data.result;
        state.totalCount = action.payload.data?.totalCount;
      })
      .addCase(updateBlog.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateBlog.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(updateBlog.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
      })
      .addCase(getBlogById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBlogById.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getBlogById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.blogById = action.payload.data;
      })
      .addCase(getReviews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReviews.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getReviews.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.reviewsData = action.payload.data.result;
        state.totalCount = action.payload.data?.totalCount;
      })
      .addCase(deleteReview.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteReview.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(deleteReview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
      })
      .addCase(deleteContactUs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteContactUs.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(deleteContactUs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
      })
      .addCase(getReviewById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReviewById.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getReviewById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.reviewById = action.payload.data;
      })
      .addCase(addBlog.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addBlog.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(addBlog.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
      })
      .addCase(getContactUs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getContactUs.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getContactUs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.contactUsData = action.payload.data.result;
        state.totalCount = action.payload.data?.totalCount;
      })
      .addCase(getCallRequests.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCallRequests.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getCallRequests.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.callRequestData = action.payload.data.result;
        state.totalCount = action.payload.data?.totalCount;
      })
      .addCase(getCourseOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCourseOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getCourseOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.courseOrdersData = action.payload.data.result;
        state.totalCount = action.payload.data?.totalCount;
      })
      .addCase(getExamOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getExamOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getExamOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.examOrdersData = action.payload.data.result;
        state.totalCount = action.payload.data?.totalCount;
      })
      .addCase(addReview.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addReview.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(addReview.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
      })
      .addCase(getAvailableCourses.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAvailableCourses.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getAvailableCourses.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.availableCourseData = action.payload.data.result;
        state.totalCount = action.payload.data?.totalCount;
      })
      .addCase(addNewCourse.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addNewCourse.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(addNewCourse.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
      })
      .addCase(getAvailableCourseById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAvailableCourseById.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getAvailableCourseById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.availableCourseById = action.payload.data;
      })
      .addCase(updateCourse.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCourse.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(updateCourse.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
      })
      .addCase(addNewExam.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addNewExam.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(addNewExam.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
      })
      .addCase(getAvailableExams.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAvailableExams.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getAvailableExams.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.availableExamData = action.payload.data.result;
        state.totalCount = action.payload.data?.totalCount;
      })
      .addCase(getAvailableExamById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAvailableExamById.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getAvailableExamById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.availableExamById = action.payload.data;
      })
      .addCase(getBatchOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBatchOrders.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(getBatchOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
        state.batchOrderData = action.payload.data.result;
      })
      .addCase(updateExam.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateExam.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(updateExam.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.message = action.payload.message;
      })
  },
});

export const { 
  setReviewById,
  setSetBlogById,
  setSetIsNewBlog,
  setStudentsById,
  setExamSearchText,
  setCourseSearchText,
  setStudentsFilterDetails } = studentsSlice.actions;

export default studentsSlice.reducer;
